import http from "@/http-common";
import lambdahttp from "@/http-lambda-common";
const baseurl = process.env.VUE_APP_AWS_SALENOTE_API

class IssueSalesNoteDataService {
  getDistributorName(data:any): Promise<any> {
      const url = baseurl + `/kdpsalesnote`;
      return lambdahttp.post<any>(url, data)
  }
  getStatusDetailLambda(data:any): Promise<any> {
      const url = baseurl + `/kdpsalesnote`;
      return lambdahttp.post<any>(url, data)
  }
  getKDPUserListLmabda(data:any): Promise<any> {
      const url = baseurl + `/kdpsalesnote`;
      return lambdahttp.post<any>(url, data)
  }
  getKDPSalesNoteStatusList(data: any): Promise<any> {
    return http.api.post("/getKDPSalesNoteStatusList/", data);
  }
  getKDPIssueSalesNoteInfoList(data: any): Promise<any> {
    return http.api.post("/getKDPIssueSalesNoteInfoList/", data);
  }
  updateKDPSalesNoteApprovalStatus(data: any): Promise<any> {
    return http.api.post("/updateKDPSalesNoteApprovalStatus/", data);
  }
  updateKDPSalesNoteApprovalStatusList(data: any): Promise<any> {
    return http.api.post("/updateKDPSalesNoteApprovalStatusList/", data);
  }
  getPreSignedUrl(data: any): Promise<any>{
    return http.api.post('/getPreSignedUrl/', data);
  }
  getScanUserNameForApproval(data: any): Promise<any> {
    return http.api.post("/getScanUserNameForApproval/", data);
  }
  getKDPUserList(data: any): Promise<any> {
    return http.api.post("/getKDPUserList/",data);
  }
  updateKDPSaleNoteApproval(data: any): Promise<any> {
    return http.api.post("/updateKDPSaleNoteApproval/",data);
  }
  getStatusDetail(data: any): Promise<any> {
    return http.api.post("/getStatusDetail/",data);
  }
  checkAndUpdateKDPIssueSalesNoteInfoList(data: any): Promise<any> {
    return http.api.post("/checkAndUpdateKDPIssueSalesNoteInfoList/",data);
  }
  updateKDPCancelSalesNote(data: any): Promise<any> {
    return http.api.post("/updateKDPCancelSalesNote/",data);
  }
}

export default new IssueSalesNoteDataService();
